export default __webpack_public_path__ + "static/media/img-0538-slovakia-full-face.1eb36bce.png";